/**
 * Scale/Edit modal – footer action buttons.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Copy, Send, Settings2 } from 'lucide-react';

import { Button } from '@/components/ui';

interface ScaleOrEditFooterProps {
  isEdit: boolean;
  isCreateFromLists?: boolean;
  showingLoader: boolean;
  canConfirm: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ScaleOrEditFooter: FC<ScaleOrEditFooterProps> = ({
  isEdit,
  isCreateFromLists = false,
  showingLoader,
  canConfirm,
  onCancel,
  onConfirm,
}) => (
  <>
    <Button variant="outline" onClick={onCancel} disabled={showingLoader}>
      Cancel
    </Button>
    <Button onClick={onConfirm} disabled={showingLoader || !canConfirm} loading={showingLoader} className="gap-2">
      {isEdit
        ? <><Settings2 className="h-4 w-4" /> Save</>
        : isCreateFromLists
          ? <><Copy className="h-4 w-4" /> Copy as draft</>
          : <><Send className="h-4 w-4" /> Scale &amp; send</>
      }
    </Button>
  </>
);
